<template>
  <div class="settings">
    <h1>系统设置</h1>
    <v-card class="mb-4">
      <v-card-title>基本设置</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="settings.siteName"
            label="网站名称"
            required
            :rules="[v => !!v || '网站名称不能为空']"
          ></v-text-field>
          <v-textarea
            v-model="settings.siteDescription"
            label="网站描述"
            rows="2"
          ></v-textarea>
          <v-switch
            v-model="settings.maintenance"
            label="维护模式"
            color="primary"
          ></v-switch>
          <v-text-field
            v-model="settings.contactEmail"
            label="联系邮箱"
            :rules="emailRules"
          ></v-text-field>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="mb-4">
      <v-card-title>安全设置</v-card-title>
      <v-card-text>
        <v-select
          v-model="settings.loginAttempts"
          :items="[3, 5, 10]"
          label="最大登录尝试次数"
        ></v-select>
        <v-select
          v-model="settings.sessionTimeout"
          :items="[15, 30, 60, 120]"
          label="会话超时时间(分钟)"
        ></v-select>
        <v-switch
          v-model="settings.twoFactorAuth"
          label="启用两步验证"
          color="primary"
        ></v-switch>
      </v-card-text>
    </v-card>
    <v-btn color="primary" :disabled="!valid" @click="saveSettings">
      保存设置
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SystemSettings',
  data () {
    return {
      valid: true,
      settings: {
        siteName: '系统管理平台',
        siteDescription: '专业的后台管理系统',
        maintenance: false,
        contactEmail: 'admin@example.com',
        loginAttempts: 5,
        sessionTimeout: 30,
        twoFactorAuth: false
      },
      emailRules: [
        v => !!v || '邮箱不能为空',
        v => /.+@.+\..+/.test(v) || '邮箱格式不正确'
      ]
    }
  },
  methods: {
    saveSettings () {
      if (this.$refs.form.validate()) {
        // 实现保存设置的逻辑
        console.log('Saving settings:', this.settings);
        this.$store.commit('showSnackbar', {
          text: '设置已保存',
          color: 'success'
        });
      }
    }
  }
}
</script>

<style scoped>
.settings {
  padding: 20px;
}
</style>
